import React, { PureComponent } from "react";

import styles from "./Footer.local.scss";
import classnames from "classnames";

import { TTP_LOGO_URL } from "Config";
import _ from "i18n";

export default class FooterComponent extends PureComponent {
  render() {
    //return null;
    return (
      <footer>
        <div className={styles.footer}>
          <div className={classnames(styles.topFooter, "grid-x")}>
            <div
              className={classnames(styles.footerLogo, "cell small-6 medium-2")}
            >
              <img src="/img/footer-logo.svg" alt="logo" />
            </div>
            <ul
              className={classnames(
                styles.footerSocial,
                "cell small-6 medium-3"
              )}
            >
              <li>
                <i className="icon icon-social-facebook" />
              </li>
              <li>
                <i className="icon icon-social-linkedin" />
              </li>
              <li>
                <i className="icon icon-social-twitter" />
              </li>
              <li>
                <i className="icon icon-social-instagram" />
              </li>
            </ul>
            <div
              className={classnames(
                styles.footerDesc,
                "cell small-12 medium-7"
              )}
            >
              <p>
                <span>Tamtam.pro</span>
                {_(
                  "est une suite d'outils qui permet à une communauté de communiquer, partager, organiser ou collaborer efficacement. La plateforme est équipée de diverses applications assemblées selon les besoins par le client. Grace à nos outils mutualisés, nos clients disposent des dernières technologies sans devoir en assurer le développement au profit leur core business."
                )}
              </p>
            </div>
          </div>
          <div className={styles.bottomFooter}>
            {_("© Copyright - 2019 Tamtam International")}
          </div>
        </div>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/FooterComponent.js